var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading.fullscreen.lock",value:(_vm.fullscreenLoading),expression:"fullscreenLoading",modifiers:{"fullscreen":true,"lock":true}}],staticStyle:{"display":"none"}},[_vm._v("\n  加载数据...\n")])}
var staticRenderFns = []

export { render, staticRenderFns }